import type { StoredConsent } from '@/lib/cookieConsent';
import { applyGoogleAnalyticsConsent } from '@/lib/googleTags';
import { unloadChatWidget } from '@/lib/loadChatWidget';
import { trackLandingPageView } from '@/lib/tracking';

export function applyConsentServices(consent: StoredConsent): void {
  applyGoogleAnalyticsConsent(consent.analytics);

  if (consent.analytics) {
    trackLandingPageView(window.location.pathname);
  }

  // Landing usa botón flotante a WhatsApp (no widget embebido).
  unloadChatWidget();
}
